import { apiFetcher } from '~/apis/api-fetcher';

type Params = {
  device: string;
  inventoryId: string;
  category?: string;
};

type Response = {
  type: 'INHOUSE' | 'KAKAO' | 'EXTERN_AD' | 'AD_POPCORN' | 'BUZZVIL' | 'ADPIE' | 'ADMOB' | 'REGION_TARGET';
  imageType: 'IMAGE' | 'LOTTIE';
  webUrl: string;
  appUrl: string;
  imageUrl: string;
  iconUrl?: string; // Optional
  title: string;
  subtitle: string;
  label?: string; // Optional
  startAt: string;
  endAt: string;
  bannerId: string;
  impId: string;
  refSource: string;
  refMedium: string;
  refCampaign: string;
  refContent: string;
  refCode: string;
  refTest: string;
};

export const getBanner = (params: Params) => apiFetcher.get<{ data: Response[] }>('/api/cms/v2/banner', params);
